import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  ModalItem,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  ButtonItem,
  TextAreaItem,
  ErrorItem,
} from "../../../../../Components/Items";
import SelectClientesItem from "../../../../../Components/SelectClientesItem";
import { Row, Col, Spin, message, Select, Form as FormInicial, Divider } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { ALCANCE, OPCIONES_ALCANCE } from "../../../../../Utils/reglasPrecio";

const { Option } = Select;

class ModalReglaPrecio extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    precios: [],
    tiposDeCliente: [],
    familias: [],
    marcas: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible === this.props.visible) return;

    if (this.props.visible) {
      this.consultarCatalogos();
      this.formRef.current.resetFields();
      if (this.props.modo === "editar" && this.props.regla) {
        // La regla llega completa desde el renglon de la tabla.
        const regla = this.props.regla;
        this.formRef.current.setFieldsValue({
          precioId: regla.precioId,
          alcance: Number(regla.alcance),
          tipoClienteId: regla.tipoClienteId,
          clienteId: regla.clienteId,
          familiaId: regla.familiaId,
          marcaId: regla.marcaId,
          porcentaje: regla.porcentaje,
          margenMinimo: regla.margenMinimo,
          margenMaximo: regla.margenMaximo,
          descuentoMinimo: regla.descuentoMinimo,
          descuentoMaximo: regla.descuentoMaximo,
          escalas: regla.escalas || [],
          observaciones: regla.observaciones,
        });
      }
    }
  }

  consultarCatalogos() {
    this.setState({ loading: true });
    axios
      .post(
        "reglasPrecio/datosParaReglaPrecio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            precios: res.data.precios || [],
            tiposDeCliente: res.data.tiposDeCliente || [],
            familias: res.data.familias || [],
            marcas: res.data.marcas || [],
          });
        } else {
          message.error("No se pudieron cargar los catalogos");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error al cargar los catalogos");
      });
  }

  atras(recargar) {
    this.formRef.current.resetFields();
    if (this.props.onClose) this.props.onClose(recargar);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });

    const esEditar = this.props.modo === "editar";
    const ruta = esEditar ? "editarReglaPrecio" : "agregarReglaPrecio";

    axios
      .post(
        `reglasPrecio/${ruta}`,
        {
          ...values,
          empresaId: this.props.empresaId,
          reglaId: esEditar ? this.props.regla?._id : undefined,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(esEditar ? "Se edito la regla" : "Se agrego la regla");
          this.atras(true);
        } else if (res.data.success === 1) {
          message.warning(res.data.message || "No se pudo guardar la regla");
        } else {
          message.error("Hubo un error y no se guardo la regla");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error y no se guardo la regla");
      });
  }

  render() {
    return (
      <ModalItem
        title={this.props.modo === "editar" ? "Editar Regla de Precio" : "Agregar Regla de Precio"}
        visible={this.props.visible}
        onCancel={() => this.atras(false)}
        footer={null}
        width={760}
      >
        <Spin spinning={this.state.loading}>
          <Form
            ref={this.formRef}
            name="reglaPrecio"
            layout
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={[16, 0]}>
              <Col span={12}>
                <FormItem
                  label="Lista de precios"
                  name="precioId"
                  required
                  margin
                  tooltip="La lista sobre la que aplica esta regla."
                >
                  <SelectItem placeholder="Lista de precios">
                    {this.state.precios.map((precio) => (
                      <Option value={precio._id} key={precio._id}>
                        {precio.nombre}
                      </Option>
                    ))}
                  </SelectItem>
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Alcance"
                  name="alcance"
                  required
                  margin
                  initialValue={ALCANCE.LISTA}
                  tooltip="A quien aplica: a toda la lista, a un tipo de cliente o a un cliente en particular."
                >
                  <SelectItem placeholder="Alcance">
                    {OPCIONES_ALCANCE.map((o) => (
                      <Option value={o.valor} key={o.valor}>
                        {o.etiqueta}
                      </Option>
                    ))}
                  </SelectItem>
                </FormItem>
              </Col>

              {/* El id que se pide depende del alcance elegido */}
              <Col span={24}>
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const alcance = Number(getFieldValue("alcance"));

                    if (alcance === ALCANCE.TIPO_CLIENTE) {
                      return (
                        <FormItem label="Tipo de cliente" name="tipoClienteId" required margin>
                          <SelectItem placeholder="Tipo de cliente">
                            {this.state.tiposDeCliente.map((tipo) => (
                              <Option value={tipo._id} key={tipo._id}>
                                {tipo.nombre}
                              </Option>
                            ))}
                          </SelectItem>
                        </FormItem>
                      );
                    }

                    if (alcance === ALCANCE.CLIENTE) {
                      return (
                        <FormItem label="Cliente" name="clienteId" required margin>
                          <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            width="100%"
                            placeholder="Cliente"
                          />
                        </FormItem>
                      );
                    }

                    return null;
                  }}
                </FormItem>
              </Col>

              <Col span={12}>
                <FormItem
                  label="Familia"
                  name="familiaId"
                  margin
                  tooltip="Deja vacio para que la regla aplique a todo el catalogo."
                >
                  <SelectItem placeholder="Todas las familias" allowClear>
                    {this.state.familias.map((familia) => (
                      <Option value={familia._id} key={familia._id}>
                        {familia.nombre}
                      </Option>
                    ))}
                  </SelectItem>
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Marca"
                  name="marcaId"
                  margin
                  tooltip="Deja vacio para que la regla aplique a todas las marcas. Una regla por marca gana sobre una por familia."
                >
                  <SelectItem placeholder="Todas las marcas" allowClear>
                    {this.state.marcas.map((marca) => (
                      <Option value={marca._id} key={marca._id}>
                        {marca.nombre}
                      </Option>
                    ))}
                  </SelectItem>
                </FormItem>
              </Col>
            </Row>

            <Divider orientation="left" style={{ marginTop: 8, marginBottom: 8 }}>
              Valores (deja vacio lo que quieras heredar del nivel anterior)
            </Divider>

            <Row gutter={[16, 0]}>
              <Col span={8}>
                <FormItem
                  label="Porcentaje sugerido"
                  name="porcentaje"
                  margin
                  tooltip="Margen que se propone para insumos nuevos. NO cambia el porcentaje fijo de los insumos ya capturados."
                >
                  <InputNumberItem placeholder="Heredar" porcentaje />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Margen minimo" name="margenMinimo" margin>
                  <InputNumberItem placeholder="Heredar" porcentaje />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Margen maximo" name="margenMaximo" margin>
                  <InputNumberItem placeholder="Heredar" porcentaje />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Descuento minimo" name="descuentoMinimo" margin>
                  <InputNumberItem placeholder="Heredar" porcentaje />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem
                  label="Descuento maximo"
                  name="descuentoMaximo"
                  margin
                  tooltip="Tope de descuento de la linea. Las escalas por cantidad, si las hay, ganan sobre este valor."
                >
                  <InputNumberItem placeholder="Heredar" porcentaje />
                </FormItem>
              </Col>
            </Row>

            <Divider orientation="left" style={{ marginTop: 8, marginBottom: 8 }}>
              Escalas por cantidad
            </Divider>

            <FormInicial.List name="escalas">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <Row key={key} gutter={[8, 0]} align="middle">
                      <Col span={7}>
                        <FormItem
                          {...restField}
                          label="Desde"
                          name={[name, "cantidadDesde"]}
                          fieldKey={[fieldKey, "cantidadDesde"]}
                          required
                          margin
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }}
                        >
                          <InputNumberItem placeholder="1" min={0} />
                        </FormItem>
                      </Col>
                      <Col span={7}>
                        <FormItem
                          {...restField}
                          label="Hasta"
                          name={[name, "cantidadHasta"]}
                          fieldKey={[fieldKey, "cantidadHasta"]}
                          margin
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }}
                          tooltip="Vacio = sin tope. Solo la ultima escala puede quedar sin tope."
                        >
                          <InputNumberItem placeholder="Sin tope" min={0} />
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem
                          {...restField}
                          label="Desc. max"
                          name={[name, "descuentoMaximo"]}
                          fieldKey={[fieldKey, "descuentoMaximo"]}
                          margin
                          labelCol={{ span: 12 }}
                          wrapperCol={{ span: 12 }}
                        >
                          <InputNumberItem placeholder="0" porcentaje />
                        </FormItem>
                      </Col>
                      <Col span={2}>
                        <ButtonItem
                          rojo2
                          lessTime
                          icon={<DeleteOutlined />}
                          onClick={() => remove(name)}
                        />
                      </Col>
                    </Row>
                  ))}
                  <div style={{ textAlign: "center", marginTop: 4 }}>
                    <ButtonItem
                      cyan
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar Escala
                    </ButtonItem>
                  </div>
                </>
              )}
            </FormInicial.List>

            <FormItem label="Observaciones" name="observaciones" margin>
              <TextAreaItem placeholder="Opcional" rows={2} />
            </FormItem>

            <Row justify="end" gutter={[8, 0]} style={{ marginTop: 12 }}>
              <Col>
                <ButtonItem onClick={() => this.atras(false)}>Cancelar</ButtonItem>
              </Col>
              <Col>
                <ButtonItem type="primary" htmlType="submit" loading={this.state.loading}>
                  {this.props.modo === "editar" ? "Guardar" : "Agregar"}
                </ButtonItem>
              </Col>
            </Row>
          </Form>
        </Spin>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalReglaPrecio);
